import styled from 'styled-components'
import {spacing} from '../../../../theme/spacing'

export const Logo = styled.div`
    margin-right: ${spacing(10)};
    height: 46px;
    display: flex;
    align-items: center;
`
